import React, { Component, Link } from 'react';
import { Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon, InputGroupText, FormText } from 'reactstrap';
import AuthService from '../../../components/AuthService';
import { ToastContainer, toast } from 'react-toastify';
import ContentLoader from "react-content-loader"

class Login extends Component {

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleForgottenPassword = this.handleForgottenPassword.bind(this);
    this.Auth = new AuthService();
  }

  validateField(fieldName, value) {
    if (value == null) {
      return false;
    }
    switch (fieldName) {
      case 'email':
        return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        break;
      case 'password':
        return value.length >= 4;
        break;
      default:
        return true;
        break;
    }
  }

  notifyError(err) {
    toast.error(err);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  handleForgottenPassword(e) {
    e.preventDefault();
    this.props.history.replace('/forgottenpassword');
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if ((!this.state) || (!this.validateField('email', this.state.email) || (!this.validateField('password', this.state.password)))) {
      this.notifyError('Veuillez reessayer. Les informations entrées ne sont pas correctes ou manquantes.');
      return;
    }
    this.setState({ loading: true });
    this.Auth.login(this.state.email, this.state.password)
      .then(res => {
        this.setState({ loading: false });
        this.props.history.replace('/');
        this.notifySuccess('Bienvenue sur la documentation de l\'API pour HappyQuest "' + this.Auth.getProfile().sub + '" !');
      })
      .catch(err => {
        this.setState({ loading: false });
        this.notifyError(err.toString());
      })
  }

  handleChange(e) {
    if (e.target.name == "email") {
      e.target.value = e.target.value.trim();
    }
    this.setState(
      {
        [e.target.name]: e.target.value
      }
    )
    if (((e.target.name == "email") && (this.validateField('email', e.target.value))) || ((e.target.name == "password") && (this.validateField('password', e.target.value)))) {
      e.target.style = "border-color : green";
    } else {
      e.target.style = "border-color : red";
    }
  }

  componentWillMount() {
    if (this.Auth.loggedIn()) {
      this.props.history.replace('/');
    }
  }

  componentDidMount() {
    this.setState({});
  }

  render() {
    let content, loading;
    if (!this.state) {
      content = <ContentLoader
        height={200}
        width={400}
        speed={2}
        primaryColor={"#f3f3f3"}
        secondaryColor={"#ecebeb"}
      >
        <rect x="7" y="17" rx="4" ry="4" width="126.36" height="11.14" />
        <rect x="11" y="33.9" rx="3" ry="3" width="107.1" height="11.26" />
        <rect x="3" y="58" rx="3" ry="3" width="385" height="28.48" />
        <rect x="3" y="95" rx="3" ry="3" width="385" height="28.48" />
        <rect x="9" y="143.9" rx="0" ry="0" width="105" height="24" />
        <rect x="310" y="153.9" rx="0" ry="0" width="78" height="9" />
      </ContentLoader>;
    } else {
      if (this.state.loading) {
        loading = <img src="/img/loading_icon.gif" style={{ height: 'auto', width: 'auto', maxWidth: 70 + 'px', maxHeight: 70 + 'px' }} />
      }
      content = <CardBody>
        <h1>Documentation HappyQuest</h1>
        <p className="text-muted">Connexion</p>
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className="icon-user"></i>
            </InputGroupText>
          </InputGroupAddon>
          <Input
            placeholder="Email"
            name="email"
            type="text"
            onChange={this.handleChange}
            required
          />
        </InputGroup>
        <InputGroup className="mb-4">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <i className="icon-lock"></i>
            </InputGroupText>
          </InputGroupAddon>
          <Input
            placeholder="Mot de passe"
            name="password"
            type="password"
            onChange={this.handleChange}
            required
          />
        </InputGroup>
        <Row>
          <Col xs="6">
            <Button color="primary" className="px-4" onClick={this.handleFormSubmit}>Se connecter</Button>
            {loading}
          </Col>
        </Row>
      </CardBody>
    }
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer />
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  {content}
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js